function AdminController($scope,$controller,$location,$timeout,$rootScope, $upload, $state, $q, GeneralUtilsService, $transitions, UserContextService, CopyToClipboardService) {
	$controller('BaseController', {$scope: $scope, $location:$location,$timeout:$timeout, $state: $state, $q: $q, $transitions: $transitions,
		GeneralUtilsService: GeneralUtilsService, UserContextService: UserContextService, CopyToClipboardService: CopyToClipboardService
		});

	const fileTypes = ['LDAP_DATA', 'ikegremapping', 'acounts2loadmapping', 'popCom', 'unassignSocket', 'HTML_FILE',
		'CSV_FILE', 'IMAGE', 'cloudAccessPortalService', 'globalCloudAppAuth', 'CERTIFICATE_PEM', 'steeringDns', 'globalRpf', 'JSON_FILE'];

	const ACCOUNT_LIST_REGEX_VALIDATION = /^\d+(,\d+)*$/;

	let defaultTime = new Date();
	defaultTime.setHours(23);
	defaultTime.setMinutes(59);
	defaultTime.setSeconds(59);
	$rootScope.dateRange = {
		start: parseInt($location.search()["start"]) || defaultTime.getTime() - 604799999,
		end: parseInt($location.search()["end"]) || defaultTime.getTime(),
	};
	$scope.location = $location;
	$scope.selectedProperty = null;
	$scope.expandedTreeNodes = [];
	$scope.selectedRevlitePath = ""
	$scope.fileDeletionRequest = {}
	$scope.pendingEvents = {};

	$scope.typesToPublishExplanations = {
		"ALL": "Publish all files under account including Sites, Users, Policies, and other assets",
		"ACCOUNT": "Publish only account proto",
		"SITE": "Publish protos of all sites belonging to the account",
		"GLOBAL": "Publish only global configuration, account list will be ignored with this option selected",
		"BLOCKPAGE": "Publish only block-page assets of the account",
		"POLICY": "Publish only Policy Platform managed files.",
		"USERS_SERVICE_PROTOBUF": "Publish only user protobuf files belonging to the account",
		"USER_SERVICE_CSV": "Publish `usersData.csv` and `usersUA.csv` belonging to the account",
		"ACCOUNT_CUSTOM_SERIALIZER": "Publish only @CustomSerializer assets of the account",
		"CERTIFICATES": "Publish only certificates of the account",
		"TLS_CERTIFICATES": "Publish only TLS Certificates of the account",
		"REDIRECT_PAGE_DATA": "Publish only redirect page data of the account",
		"SDP_IP_ALLOCATION": "Publish only `user_ip_mapping.csv` of the account",
		"DEVICES": "Publish all devices of the account",
		"CONTAINER": "Publish all account's container files",
		"GROUPS": "Publish new groups revlite file",
	  	"CLIENT_NOTIFICATION_CONFIGURATION": "Publish all the customized client notifications of the account"
	};

	$scope.typesToPublish = Object.keys($scope.typesToPublishExplanations)

	$scope.revlitePublishRequest  = {
		accountId: $state.params.accountId || null,
		typeToPublish: "ALL"
	};



	$scope.pages = [
		{"label":"Components", "state":"admin.components"},
		{"label":"Remote Revlite","state":"admin.newrevlite"},
		{"label":"System Properties","state":"admin.sysprops"},
		{"label":"Component Metrics","state":"admin.componentmetrics"},
		{"label":"Domains Monitoring","state":"admin.admindomains"},
		{"label":"Classification Console","state":"admin.adminClassificationconsole"},
		{"label":"Realtime Data","state":"admin.realtime"},
		{"label":"Connected Web Users","state":"admin.connectedusers"},
		{"label":"Scheduled Jobs","state":"admin.scheduledjobs"},
		{"label":"Persistent Jobs","state":"admin.persistentjobs"},
		{"label":"General Properties","state":"admin.allgeneralproperties"},
		{"label":"Socket Platform Versions","state":"admin.socketsPlatformVersions"},
		{"label":"Sockets Platform Groups","state":"admin.socketsPlatformGroups"},
		{"label":"Scim Query","state":"admin.scimQuery"},
		{"label":"Ldap Query","state":"admin.ldapQuery"},
		{"label":"Users Service Sync","state":"admin.usersServiceSync"},
		{"label":"Generic Account Migration","state":"admin.genericAccountMigration"},
		{"label":"General Properties Migration","state":"admin.generalPropertiesMigration"},
		{"label":"IkeV2 to Multi Tunnel Configuration Migration","state":"admin.ikeV2ConfToMultiTunnelConfMigration"},
		{"label":"Remote Access Job","state":"admin.remoteAccessJob"},
		{"label":"DLP Account Configuration","state":"admin.dlpCustomContent"},
		{"label":"RBI Account Configuration","state":"admin.rbiConfigurationContent"},
        {"label":"Sandbox Account Configuration","state":"admin.sandboxConfigurationContent"},
		{"label":"Antivirus Test Box","state":"admin.avTestBox"},
		{"label":"Tuneup","state":"admin.tuneup"},
		{"label":"Sockets","state":"admin.sockets"},
		{"label":"Public IPs","state":"admin.egress"},
		{"label":"Traffic Loggers","state":"admin.trafficLogging"},
		{"label":"Geolocation","state":"admin.geolocation"},
		{"label":"Notifications","state":"admin.notifications"},
		{"label":"Sms","state":"admin.sms"},
		{"label":"Owner and Admins", "state":"admin.accountOwnerAdmins"},
		{"label":"Running Event Discovery Exports", "state":"admin.runningEventDiscoveryExports"},
		{"label":"Logger configuration", "state":"admin.loggerConfig"},
		{"label":"Pop Allocated IPs", "state":"admin.popAllocatedIps"},
		{"label":"Entity Version Cache", "state": "admin.entityVersionCache"},
		{"label":"Gradually tag release/removal","state":"admin.tagAddOrRemove"},
		{"label":"Regional CMA","state":"admin.regionalCma"},
		{"label":"License Actions","state":"admin.licenseActions"},
		{"label":"RBAC Roles","state":"admin.rbacRoles"},
	];

    $scope.revliteSorter = function (input) {
        if (input) {
            input.children.sort(function (a, b) {
				var intA = parseInt(a.name, 10);
				var intB = parseInt(b.name, 10);
				if (!intA) {
					if (!intB) {
						if (a.name > b.name) {
							return 1;
						}
						return -1;
					}
					return -1;
				}
				if (!intB) {
					return 1;
				}

				if(intA > intB) {
					return 1;
				}

				return -1;
            });

			input.children.forEach(function (item) {
				$scope.revliteSorter(item);
			});
        }
        return input;
    };

    $transitions.onStart({}, function(transition) {
        var toState = transition.to();
        var toParams = transition.params('to');
        var fromState = transition.from();

        if (fromState && fromState.workProtect && $rootScope.hasChanges) {
			if ($rootScope.hasChanges()) {
				var message = "You have unsaved changes. Press 'OK' to leave this page and discard your changes or press 'Cancel' to stay on this page.";

				$rootScope.confirm(message,
					function(){
						$rootScope.hasChanges = function(){
							return false;
						};
						$state.go(toState, toParams);
					}
				);
				return false;
			}
		}
		return true;
    });

    $transitions.onFinish({}, function(transition) {
        var toState = transition.to();

        switch(toState.name){
        	case 'admin.revlite' :
        	case 'admin.newrevlite' :
        	$scope.revlitePublishRequest  = {
                accountId: $state.params.accountId || null,
				typeToPublish: "ALL"
            };
            $scope.revlitePublishSiteOrLoginRequest  = {
                accountId: $state.params.accountId || null,
                siteOrLoginProtoId: $state.params.siteOrLoginProtoId || null
            };

            break;
            case 'admin.sysprops' :
            store.fetch({
            		method : 'GET',
            		url : '/catoadmin/manualJobs',
            		success: function(data, status, headers, config) {
            			$timeout(function() {
            				$scope.jobList = data;
            			}, 1);
            		}
            	});
            break;
			case 'admin.remoteAccessJob':
				$scope.remoteAccessJobRequest = {
					accountId: $state.params.accountId || null,
				};
				break;
			case 'admin.genericAccountMigration':
				$scope.genericMigrationRequest = {
					accountIds: $state.params.accountIds || null,
				};
				break;
			case 'admin.generalPropertiesMigration':
				$scope.generalPropertiesMigrationRequest = {
					accountIds: $state.params.accountIds || null,
				};
				break;
			case 'admin.regionalCma':
				$scope.regionalCmaRequest = {
				};
				break;
			case 'admin.rbacRoles':
				$scope.rbacRolesRequest = {
				};
				break;
            case 'admin.ikeV2ConfToMultiTunnelConfMigration':
                $scope.ikeV2ConfToMultiTunnelConfMigrationRequest = {
                    accountIds: $state.params.accountIds || null,
                };
                break;
        }
		$scope.dataURL = toState.dataURL;
		refreshData(toState, transition.params().accountId);
    });

    $transitions.onSuccess({}, function(transition) {
        var current = transition.to();

        if (current.name === 'admin'){
        	$state.go('admin.components', {}, {
        		location: 'replace'
        	});
        }

        $scope.showAccountFilter = current.showAccountFilter;
        $scope.params = current.params;
        $scope.timeRange = current.timeRange;
        $scope.adminbackground = current.adminbackground;
        document.title = current.title;
        $scope.title = current.title;
        $scope.location = $location;
        $scope.pages.forEach(function(page) {
        	var items = (page.type === 'category'?page.children:[page]);
        	items.forEach(function(item) {
        		if($scope.isCurrentPage(item, current)){
        			$scope.currentPage = item.label;
        		}
        	});
        });

        $scope.accountId = parseInt($state.params.accountId);
        $scope.rtRequest = {
        	accountId: parseInt($state.params.accountId) || null
        };
        $scope.rtRequestPop = {
        	accountId: parseInt($state.params.accountId) || null
        };
        $scope.rtRequestWebapp = {
        	accountId: parseInt($state.params.accountId) || null
        };

		$scope.siteDataStorageRequest  = {
			accountId: null,
			protoId: null,
		};

		$scope.syncRealTimeDataRequest = {
			popId: null,
			accountId: null,
			force: false,
			result: null,
		};

		$scope.siteToFetch = {
        	account:  $state.params.accountId || null,
        	pid: null,
        	statsType: 'raw',
        };
        $scope.transientRtData = null;

		$scope.getImmediateTransientRealTimeData = function() {
        	$scope.loading = true;
        	store.fetch({
        		url: '/getTransientRealTimeDataFromPop/quality?account=' + $scope.siteToFetch.account + '&pid=' + $scope.siteToFetch.pid,
        		success: function(data){
        			$timeout(function() {
        				$scope.transientRtData = null;
        				$scope.loading = false;
						$scope.transientRtData = data;
        			}, 0);
        		}
        	});
        };

		$scope.trtAndLteData = null;

		$scope.getTrtAndLteRealtimeData = function() {
			$scope.trtAndLteLoading = true;
			store.fetch({
				url: '/getTransientRealTimeAndLteDataFromPop?account=' + $scope.siteToFetch.account + '&pid=' + $scope.siteToFetch.pid,
				success: function(data){
					$timeout(function() {
						$scope.trtAndLteData = null;
						$scope.trtAndLteLoading = false;
						$scope.trtAndLteData = data;
					}, 0);
				}
			});
		};

        $scope.routesToFetch = {
        	accountId:  $state.params.accountId || null,
        	popId: -1,
        	statsType: 'raw',
        };

        $scope.routesStoreConfiguration = function() {
            var path = $scope.routesToFetch.statsType === 'raw' ? '/getTransientRealTimeDataFromPop' : '/getImmediateTransientRealTimeData';
            return {
            	url: path + '/routing',
            	queryParams: {
            		accountId: $scope.routesToFetch.accountId,
            		popId: $scope.routesToFetch.popId,
            	},
            }
        }

        $scope.routesOnSuccess = function(data) {
			$scope.routesTRTData = data;
        }

        $scope.offCloudStoreConfiguration = function() {
            return {
                url: '/getImmediateTransientRealTimeData/offcloud',
                queryParams: {
                    account: $scope.siteToFetch.account,
                    pid: $scope.siteToFetch.pid,
                },
            }
        }

        $scope.offCloudOnSuccess = function(data) {
            $scope.offCloudTRTData = data;
        }

		$scope.dhcpTableStoreConfiguration = function() {
			return {
				url: '/getImmediateTransientRealTimeData/dhcp',
				queryParams: {
					account: $scope.siteToFetch.account,
					pid: $scope.siteToFetch.pid
				},
			}
		}

		$scope.dhcpTableOnSuccess = function(data) {
			$scope.dhcpTableTRTData = data;
		}

		$scope.dhcpPoolsStoreConfiguration = function() {
			return {
				url: '/getImmediateTransientRealTimeData/dhcp_pools',
				queryParams: {
					account: $scope.siteToFetch.account,
					pid: $scope.siteToFetch.pid
				},
			}
		}

		$scope.dhcpPoolsOnSuccess = function(data) {
			$scope.dhcpPoolsTRTData = data;
		}

		$scope.getProtoIdRequest  = {
			requestType: "SITE_ID",
			id: null
		};

		$scope.siteDataStorageRequest  = {
			requestType: "SITE_HISTORY"
		};

	});

	$scope.getCCUrl = function() {
		let url = window.location.origin.replace('cc2', 'cc');
		url = url.replace('adminarea.','')
		if ($scope.accountId) {
			return url + '/?#/account/' + $scope.accountId + '/topology';
		}
		return url + '/?#/account/1/accounts';
	}

	function refreshData(currentState, accountId){
		if($scope.dataURL){
			currentState = (currentState && currentState.name) || $state.current.name;

			if($scope.dataURL === "/ag/revlite" || $scope.dataURL === "/ag/new/revlite") {
			    if (accountId) {
			        $scope.dataURL = $scope.dataURL.concat("/" + accountId);
			    }
			    else {
			        $scope.dataURL = $scope.dataURL.concat("/1");
			    }
			}

			store.fetch({
				method : 'GET',
				url : $scope.dataURL,
				success: function(data) {
					if (currentState !== $state.current.name) {
						return;
					}

					$scope.data = data;

					if ($scope.dataURL === '/catoadmin/components') {
					    $scope.services = [];
					    for (let [key, value] of Object.entries($scope.data)) {
                          $scope.services.push(...value)
                        }
						$scope.viewDetails("JobServer");
					}
					else if ($scope.dataURL === '/catoadmin/sysprops') {
						updateDataForSystemProperties($scope.data);
					}
					else if ($scope.dataURL.includes("/ag/revlite")) {
						$timeout(function () {
							var parentId = "1";
							var currentAccount = 0;
							var currentParent =  _.findWhere($scope.data.files[0].children, {name: parentId});

							// if filtered by account id get the subtree of the current account
							if($state.params.accountId && $state.params.accountId != 1){
								currentAccount = _.findWhere($scope.data.files[0].children[$scope.data.files[0].children.indexOf(currentParent)].children, {name: $state.params.accountId, type: "ACCOUNT"});
							}

							// if filtered by account: show subtree of current account
							// else: show full tree
							$scope.treeData = $scope.revliteSorter(currentAccount) || $scope.revliteSorter(currentParent);

							addGlobalConfigFiles($scope.treeData);
						}, 0);
					}
					else if($scope.dataURL.includes("/ag/new/revlite")) {
						$timeout(function () {
							$scope.newRevliteData = $scope.revliteSorter($scope.data.files[0]);
							store.fetch({
								method : 'GET',
								url : '/ag/new/revliteGlobals',
								success: function(globalsResponse) {
									$scope.newRevliteData.children.push(globalsResponse)
								},
							});
						}, 0);
					}
					$scope.$digest();
				}
			});
		}
	}

    /**
      * adding statically the accounts 2 load and ike gre mapping files
      * to the tree , adding it statically since the proto serializer\deserialize
      * is not Global as loaded
	 *
	 * adding the global configuration file
    **/
	function addGlobalConfigFiles(treeData){
        var globalFile1 = {};
        globalFile1.dir = false;
        globalFile1.path = "global/1";
        globalFile1.name = "global configuration";
        globalFile1.type = "GLOBAL";
        globalFile1.children = [];
        treeData.children.push(globalFile1);

	    var globalNodeIkeGre = {};
	    globalNodeIkeGre.dir = false;
	    globalNodeIkeGre.path = "global/2";
	    globalNodeIkeGre.name = "global IkeGreMapping";
	    globalNodeIkeGre.type = "ikegremapping";
	    globalNodeIkeGre.children = [];
	    treeData.children.push(globalNodeIkeGre);

        var globalAccounts2Load = {};
        globalAccounts2Load.dir = false;
        globalAccounts2Load.path = "global/3";
        globalAccounts2Load.name = "global accounts to load";
        globalAccounts2Load.type = "acounts2loadmapping";
        globalAccounts2Load.children = [];
        treeData.children.push(globalAccounts2Load);

        var globalPopComm = {};
        globalPopComm.dir = false;
        globalPopComm.path = "global/4";
        globalPopComm.name = "global pop communication";
        globalPopComm.type = "popCom";
        globalPopComm.children = [];
        treeData.children.push(globalPopComm);

       var globalPopComm = {};
        globalPopComm.dir = false;
        globalPopComm.path = "global/5";
        globalPopComm.name = "global unassign socket";
        globalPopComm.type = "unassignSocket";
        globalPopComm.children = [];
        treeData.children.push(globalPopComm);

       var globalCloudAccessPortalService = {};
       globalCloudAccessPortalService.dir = false;
       globalCloudAccessPortalService.path = "global/6";
       globalCloudAccessPortalService.name = "global cloud access portal service";
       globalCloudAccessPortalService.type = "cloudAccessPortalService";
       globalCloudAccessPortalService.children = [];
       treeData.children.push(globalCloudAccessPortalService);

       var globalCloudAppAuth = {};
       globalCloudAppAuth.dir = false;
       globalCloudAppAuth.path = "global/7";
       globalCloudAppAuth.name = "global cloud application authentication";
       globalCloudAppAuth.type = "globalCloudAppAuth";
       globalCloudAppAuth.children = [];
       treeData.children.push(globalCloudAppAuth);

		var steeringDns = {};
		steeringDns.dir = false;
		steeringDns.path = "global/8";
		steeringDns.name = "Steering Dns";
		steeringDns.type = "steeringDns";
		steeringDns.children = [];
		treeData.children.push(steeringDns);

		var globalRpf = {};
		globalRpf.dir = false;
		globalRpf.path = "global/9";
		globalRpf.name = "global RPF";
		globalRpf.type = "globalRpf";
		globalRpf.children = [];
		treeData.children.push(globalRpf);
	}

	$(function(){
		$scope.pageReady = true;
	});

	$scope.isCurrentPage = function(page, current){
		if(!page) return false;
		return (page.state === current.name);
	};

	$scope.viewDetails = function(compId){
		$scope.selectedComp = compId;
		store.fetch({
			method : 'GET',
			url : '/catoadmin/details?id=' + compId,
			success: function(data) {
                if (data[0] && data[0]["Component State"] === "Down") {
                    $scope.metrics.showError = true;
                    $scope.metrics.errorMsg = "[" + compId + "] [Details] " + data[0]["Details"];
                }
                else {
                    $scope.metrics = (data == "null") ? null : data;
                    if($scope.metrics && $scope.metrics.customMetrics) {
						//filter out hidden from UI metrics
						$scope.metrics.customMetrics = $scope.metrics.customMetrics.filter(metric => !metric.hideFromUI);
                        for (let metric of $scope.metrics.customMetrics) {
                            let filter = baseUnitToFilter(metric.baseUnit);
                            if(filter) {
                                metric.filter = filter;
                            }
                        }
                    }
                }
			},
		});
		store.fetch({
            method : 'GET',
            url : '/catoadmin/serviceStatus?id=' + compId,
            success: function(data) {
                if (data[0] && data[0]["Component State"] === "Down") {
                    $scope.serviceStatus.showError = true;
                    $scope.serviceStatus.errorMsg = "[" + compId + "] [Service Status] " + data[0]["Details"];
                }
                else {
                    $scope.serviceStatus = (data == "null") ? null : data;
                }
            },
        });
        store.fetch({
            method : 'GET',
            url : '/catoadmin/componentAdditionalInfo?id=' + compId,
            success: function(data) {
                if (data[0] && data[0]["Component State"] === "Down") {
                    $scope.additionalInfo.showError = true;
                    $scope.additionalInfo.errorMsg = "[" + compId + "] [Additional Info] " + data[0]["Details"];
                }
                else {
                    $scope.additionalInfo = (data == "null") ? null : data;
                }
            },
        });
	};

    // Converting the path /1/49/USER/1000000004 to catod format 49:4S
	function calculateCatodLogFormat(path){
        var partsOfPath = path.split('/');
        if (partsOfPath.length === 5 && Number.isInteger(Number(partsOfPath[4]))) {
            var site = parseInt(partsOfPath[4]);
            return partsOfPath[2] + ':' + ( site >=  1000000000 ? (site - 1000000000) : site + ':V' );
        } else {
            return null;
        }
	}

	function baseUnitToFilter(baseUnit) {
	    if(!baseUnit) {
	        return false;
	    }
	    if(baseUnit == 'seconds') {
            return 'date';
        }
        return baseUnit;
	}


	$scope.treeOptions = {
		nodeChildren: "children",
		dirSelectable: true,
		injectClasses: {
			ul: "a1",
			li: "a2",
			liSelected: "a7",
			iExpanded: "a3",
			iCollapsed: "a4",
			iLeaf: "a5",
			label: "a6",
			labelSelected: "a8"
		}
	};

	$scope.nrsTreeOptions = {
		nodeChildren: "children",
		dirSelectable: false,
		isLeaf: nrsIsLeaf,
		injectClasses: {
			ul: "a1",
			li: "a2",
			liSelected: "a7",
			iExpanded: "a3",
			iCollapsed: "a4",
			iLeaf: "a5",
			label: "a6",
			labelSelected: "a8"
		},
	};

	function nrsIsLeaf(node) {
		return !node.dir;
	}

	$scope.onRevliteDirectoryClick = function(node) {
		if(node.dir && !node.fetched){
			store.fetch({
				method : 'GET',
				url : `/ag/new/listFilesInPath?path=${node.path}&accountId=${$scope.revlitePublishRequest.accountId}`,
				success: function(newNode) {
					updateNode($scope.newRevliteData, newNode);
				}
			})
		}
	}

	function updateNode(tree, node) {
		if (!tree.children?.length) {
			return
		}
		let bestMatchNode = tree;
		for (let index in tree.children) {
			let currentChild = tree.children[index];
			if(currentChild.path === node.path) {
				tree.children[index].children = node.children;
				//on purpose not updating the `fetched` flag so closing and re-opening the directory node will cause re-fetch from server.
				return
			}
			if (node.path.startsWith(currentChild.path) && bestMatchNode.path.length < currentChild.path.length) {
				bestMatchNode = currentChild;
			}
		}
		if (bestMatchNode === tree) {
			return
		}
		updateNode(bestMatchNode, node);
	}


	$scope.showSelected = function(node, remote) {
		$scope.selectedRevlitePath = node.path;
		if(node.children.length > 0) {
			$scope.proto = "";
			return;
		}
		var type;
		if(node.type === 'GLOBAL'){
			type = 'globalconfigurations';
		}
		else if(fileTypes.indexOf(node.type) >= 0){
            type = node.type;
        }
		else {
			type = (node.type === 'USER'?'site':'account');
		}
		store.fetch({
			method : 'GET',
			url : "/ag/proto?pretty=true&type=" + type + "&path=" + node.path + "&asJson=true" + "&newRevlite=" + !!remote,
			rawResponse: true,
			success: function(data) {
				$timeout(function () {
					$scope.isImage = type === 'IMAGE';
					$scope.proto = data;
					$scope.protoPathCatod = calculateCatodLogFormat(node.path);
				}, 0);
			}
		});
	};

	$scope.removeFilter = function() {
		$state.go($state.current, {
			accountId: null
		});
	};

	$scope.copyRealTimeDataToClipboard = function(data) {
		CopyToClipboardService.copy(JSON.stringify(data));
	};

	$scope.sendRealtimeSiteDataStorageRequest = function (rtRequestParams) {
		rtRequestParams.realtimeResponse = "Sending Request...";
		rtRequestParams.okResponse = undefined;

		if (!rtRequestParams.requestType) {
			rtRequestParams.realtimeResponse = "please select a request type";
			return;
		}

		if (!rtRequestParams.accountId) {
			rtRequestParams.realtimeResponse = "Account ID is missing or not an integer";
			return;
		}

		if (!rtRequestParams.protoId) {
			rtRequestParams.realtimeResponse = "Proto ID is missing or not an integer";
			return;
		}

		let api
		switch (rtRequestParams.requestType) {
			case 'SITE':
				api = 'getRealtimeSiteDataFromEntityStorage';
				break;
			case 'SITE_HISTORY':
				api = 'getRealtimeSiteDataFromEntityHistoryStorage';
				break;
			case 'USER':
				api = 'getRealtimeUserDataFromEntityStorage';
				break;
			case 'USER_HISTORY':
				api = 'getRealtimeUserDataFromEntityHistoryStorage';
				break;
			default:
				rtRequestParams.realtimeResponse = "Invalid requestType: " + rtRequestParams.requestType;
				return;
		}

		const url = `/ag/${api}?accountId=${rtRequestParams.accountId}&protoId=${rtRequestParams.protoId}&authenticityToken=${authenticityToken}`;

		store.fetch({
			method : 'GET',
			url : url ,
			success: function(data) {
				rtRequestParams.okResponse = true
				rtRequestParams.realtimeResponse = data;
			},
			error: function() {
				rtRequestParams.realtimeResponse = "Error..";
			}
		});

	}

	$scope.sendGetProtoIdRequest = function (getProtoIdRequestParams) {
		getProtoIdRequestParams.response = "Sending Request...";

		if (!getProtoIdRequestParams.requestType) {
			getProtoIdRequestParams.response = "please select a request type";
			return;
		}

		if (!getProtoIdRequestParams.id) {
			getProtoIdRequestParams.response = "ID is missing or not an integer";
			return;
		}

		let api
		switch (getProtoIdRequestParams.requestType) {
			case 'SITE_ID':
				api = 'getSiteProtoId';
				break;
			case 'USER_ID':
				api = 'getUserProtoId';
				break;
			default:
				getProtoIdRequestParams.response = "Invalid requestType: " + getProtoIdRequestParams.requestType;
				return;
		}

		const url = `ag/${api}?id=${getProtoIdRequestParams.id}&authenticityToken=${authenticityToken}`;

		store.fetch({
			method : 'GET',
			url : url ,
			success: function(data) {
				getProtoIdRequestParams.response = data;
			},
			error: function() {
				getProtoIdRequestParams.response = "Error..";
			}
		});

	}


	// -- end of realtime screen

	//voodoo - otherwise the processing page is nor responsive
	$scope.processingLoop = function() {
		$timeout($scope.processingLoop,100);
		return;
	};


	//-- start of revlite screen

    store.fetch({
        path: '/getReleaseGroups',
        success: function (data) {
            $timeout(function () {
                $scope.releaseGroups = data;
            }, 0);
        },
    });

	// generic account migration screen
	store.fetch({
		url: '/ag/getAllActionTags',
		success: function (data) {
			$timeout(function () {
				$scope.tags = data;
				console.log("tag is : " + data)
			}, 0);
		},
	});

	$scope.UserAwarenessExceptionMigration = function(migrateAccounts) {
		migrateAccounts.response = "Sending request...";
		if(!migrateAccounts || !migrateAccounts.accountIdsStr) {
			migrateAccounts.response = "Missing Parameters";
			return;
		}
		store.fetch({
			method: "POST",
			url: "/ag/migrateUserAwarenessException",
			queryParams: {accountIdsStr: migrateAccounts.accountIdsStr},
			success: function(data) {
				migrateAccounts.response = data;
			},
			error: function() {
				migrateAccounts.response = "Bad Request";
			}
		});
	}

	$scope.addAccountToRemoteAccessJob = function(account) {
		$scope.$root.confirm('Are you sure you want to add ' + account.accountId + ' to the next licensing job run?', function () {
			store.fetch({
				method : 'POST',
				url : "/ag/addAccountToRemoteAccessJob",
				queryParams: {accountIdStr: account.accountId, authenticityToken: authenticityToken},
				success: function(data) {
					account.response = data;
				},
				error: function() {
					account.response = "Bad Request";
				}
			});
		});
	}

	$scope.GenericMigrateAccounts = function(migrateAccounts) {
		migrateAccounts.response = "Sending Request...";
		if (!migrateAccounts || !migrateAccounts.accountIdsStr) {
			migrateAccounts.response = "Missing Parameters";
			return;
		}
		store.fetch({
			method : 'POST',
			url : "/ag/executeGenericMigration",
			queryParams: {
				accountIdsStr: migrateAccounts.accountIdsStr,
				migrationTag : migrateAccounts.tag,
				authenticityToken: authenticityToken
			},
			success: function(data) {
				migrateAccounts.response = "Done: " + JSON.stringify(data);
			},
			error: function() {
				migrateAccounts.response = "Bad Request";
			}
		});
	}
	$scope.GeneralPropertiesAccountMigration = function(migrateAccounts) {
		migrateAccounts.response = "Sending Request...";
		if (!migrateAccounts || !migrateAccounts.accountIdsStr || !migrateAccounts.gpName || !migrateAccounts.gpValue) {
			migrateAccounts.response = "Missing Parameters";
			return;
		}
		if (!ACCOUNT_LIST_REGEX_VALIDATION.test(migrateAccounts.accountIdsStr)) {
			migrateAccounts.response = "Please insert accounts with the right delimiter (,) with no spaces.";
			return;
		}
		store.fetch({
			method : 'POST',
			url : "/ag/addAccountsGeneralProperty",
			queryParams: {
				accountIdsStr: migrateAccounts.accountIdsStr,
				gpName : migrateAccounts.gpName,
				gpValue : migrateAccounts.gpValue,
				authenticityToken: authenticityToken
			},
			success: function(data) {
				migrateAccounts.response = "Done: " + JSON.stringify(data);
			},
			error: function() {
				migrateAccounts.response = "Bad Request";
			}
		});
	}
	$scope.GeneralPropertyRollbackAccounts = function(migrateAccounts) {
		migrateAccounts.response = "Sending Request...";
		if (!migrateAccounts || !migrateAccounts.accountIdsStr || !migrateAccounts.gpName) {
			migrateAccounts.response = "Missing Parameters";
			return;
		}
		if (!ACCOUNT_LIST_REGEX_VALIDATION.test(migrateAccounts.accountIdsStr)) {
			migrateAccounts.response = "Please insert accounts with the right delimiter (,) with no spaces.";
			return;
		}
		store.fetch({
			method : 'POST',
			url : "/ag/executeGeneralPropertyRollback",
			queryParams: {
				accountIdsStr: migrateAccounts.accountIdsStr,
				gpName : migrateAccounts.gpName,
				authenticityToken: authenticityToken
			},
			success: function(data) {
				migrateAccounts.response = "Done: " + JSON.stringify(data);
			},
			error: function() {
				migrateAccounts.response = "Bad Request";
			}
		});
	}
	$scope.GenericRollbackAccounts = function(migrateAccounts) {
		migrateAccounts.response = "Sending Request...";
		if (!migrateAccounts || !migrateAccounts.accountIdsStr) {
			migrateAccounts.response = "Missing Parameters";
			return;
		}
		store.fetch({
			method : 'POST',
			url : "/ag/executeGenericRollback",
			queryParams: {
				accountIdsStr: migrateAccounts.accountIdsStr,
				migrationTag : migrateAccounts.tag,
				authenticityToken: authenticityToken
			},
			success: function(data) {
				migrateAccounts.response = "Done: " + JSON.stringify(data);
			},
			error: function() {
				migrateAccounts.response = "Bad Request";
			}
		});
	}

	$scope.dnsPolicyMigrateAccounts = function(migrateAccounts) {
		migrateAccounts.response = "Sending Request...";
		if (!migrateAccounts || !migrateAccounts.accountIdsStr) {
			migrateAccounts.response = "Missing Parameters";
			return;
		}
		store.fetch({
			method : 'POST',
			url : "/ag/migrateDNSPolicy",
			queryParams: {accountIdsStr: migrateAccounts.accountIdsStr, authenticityToken: authenticityToken},
			success: function(data) {
				migrateAccounts.response = "Done";
			},
			error: function() {
				migrateAccounts.response = "Bad Request";
			}
		});
	}

	$scope.ccpMigrateAccounts = function(migrateAccounts) {
		migrateAccounts.response = "Sending Request...";
		if (!migrateAccounts || !migrateAccounts.accountIdsStr) {
			migrateAccounts.response = "Missing Parameters";
			return;
		}
		store.fetch({
			method : 'POST',
			url : "/ag/migrateCCP",
			queryParams: {accountIdsStr: migrateAccounts.accountIdsStr, authenticityToken: authenticityToken},
			success: function(data) {
				migrateAccounts.response = "Done";
			},
			error: function() {
				migrateAccounts.response = "Bad Request";
			}
		});
	}

	$scope.initRegionRangeAccount = function(regionalCmaRequest) {
		console.log("In initRegionRangeAccount")
		regionalCmaRequest.response = "Sending Request...";
		store.fetch({
			method : 'POST',
			url : "/ag/initAccountRange",
			success: function(data) {
				if (data.status==="OK") {
					regionalCmaRequest.response = "Done";
				} else {
					regionalCmaRequest.response = data.notifications[0].message;
				}
			},
			error: function() {
				regionalCmaRequest.response = "Bad Request";
			}
		});
	}

	$scope.migrateGlobalAccounts = function(regionalCmaRequest) {
		console.log("In migrateGlobalAccounts")
		regionalCmaRequest.response = "Sending Migrate Request...";
		store.fetch({
			method : 'POST',
			url : "/ag/migrateGlobalAccounts",
			success: function(data) {
				if (data.status==="OK") {
					regionalCmaRequest.response = "Done";
				} else {
					regionalCmaRequest.response = data.notifications[0].message;
				}
			},
			error: function() {
				regionalCmaRequest.response = "Bad Request";
			}
		});
	}


	$scope.migrateCraRoles = function(rbacRoleRequest) {
		console.log("In migrateCraRolesFromTopics")
		rbacRoleRequest.response = "Sending Migrate Request...";
		store.fetch({
			method : 'POST',
			url : "/ag/migrateCraRolesFromTopics",
			success: function(data) {
				if (data.status==="OK") {
					console.log("migrateCraRolesFromTopics Done")
					rbacRoleRequest.response = "Done;"
				} else {
					console.log("migrateCraRolesFromTopics status not OK", data)
					rbacRoleRequest.response = data.notifications[0].message;
				}
			},
			error: function() {
				console.log("Bad Request")
				rbacRoleRequest.response = "Bad Request"
			}
		});
	}

	$scope.requestFileDeletionNRS = function () {
		let confirmationMsg = `Are you sure you want to request file deletion in path: ${$scope.selectedRevlitePath}. Action is not revertible. To restore the file it will need to be republished manually or by automated trigger (audit change)`;
		if (confirm(confirmationMsg)) {
			store.fetch({
				method : 'POST',
				url : "/ag/new/deleteFileInPath",
				queryParams: {path: $scope.selectedRevlitePath, authenticityToken: authenticityToken},
				success: function() {
					$scope.fileDeletionRequest.response = "Requested";
				},
				error: function(err) {
					$scope.fileDeletionRequest.response = "Error " + err;
				}
			});
		}
	}

    $scope.revlitePublishAccount = function(publishAccount) {
        publishAccount.response = "Sending Request...";
		publishAccount.responseJson = null;
		if (!publishAccount || (!publishAccount.accountId && !publishAccount.accountIds && !publishAccount.group)) {
			publishAccount.response = "Missing Parameters";
            return;
        }
        store.fetch({
            method : 'POST',
            url : (publishAccount.accountId || publishAccount.accountIds  ? "/ag/publishAccount" : "/ag/publishReleaseGroup"),
            queryParams: {
				accountIds: !publishAccount.accountIds ?  publishAccount.accountId : publishAccount.accountIds,
				typeToPublish: !publishAccount.typeToPublish ? "ALL" : publishAccount.typeToPublish,
				group: publishAccount.group,
				forcePublish: publishAccount.forcePublish === undefined ? false : publishAccount.forcePublish,
				parallel: publishAccount.parallel === undefined ? false : publishAccount.parallel,
				authenticityToken: authenticityToken
			},
            success: function(data) {
				if (data.status === "OK") {
					publishAccount.response = "Done " + data.status
				}
			},
            error: function(err) {
                publishAccount.response = "Error "
				publishAccount.responseJson = JSON.stringify(err);
            }
        });

    };

    $scope.revlitePublishSiteOrLogin = function(publishSite) {

        publishSite.response = "Sending Request...";
        if (!publishSite || !publishSite.accountId || !publishSite.siteOrLoginProtoId) {
            publishSite.response = "Missing Parameters";
            return;
        }
        store.fetch({
            method : 'POST',
            url : "/ag/publishSiteOrAccessLogin",
            queryParams: {
				accountIdStr: publishSite.accountId,
				protoIdStr: publishSite.siteOrLoginProtoId,
				forcePublish: publishSite.forcePublish === undefined ? false: publishSite.forcePublish,
				authenticityToken: authenticityToken
			},
            success: function(data) {
            	if (data.status === "OK") {
					publishSite.response = "Done " + data.status
				} else {
					publishSite.response = "Done " + data.status + " : " + data?.notifications[0]?.message;
				}
            },
            error: function(err) {
                publishSite.response = "Error " + err
            }
        });

    };

	$scope.copyToClipboard = function() {
		CopyToClipboardService.copy($scope.proto);
	};

	//-- end of revlite screen


    // Start of system properties screen
	$scope.editSystemProp = function(){
		let changedProperty = {name: $scope.selectedPropery.name ,'value': $scope.selectedPropery.value};
		store.save({
			path: "/catoadmin/changesysprops",
			dataObj: 'json',
			queryParams: changedProperty,
			success: function(data) {
				$scope.$root.handleServerResponse(data,"", "Property changed successfully");
				updateDataForSystemProperties([changedProperty]);
			}
		});
	};

	function updateDataForSystemProperties (data){
		var suppressAlerts = data.filter(function(prop) { return prop.name == 'suppress_alerts_for_types' })[0];
		if (suppressAlerts){
			$scope.suppressAlertsTypes = suppressAlerts.value;
		}
	}

	$scope.goingToDeploy = function(partialAction, useMessage, holdAlerts){
    	store.save({
    		path: "/catoadmin/goingToDeploy",
    		dataObj: 'json',
    		queryParams: {partialAction: partialAction, useMessage: useMessage, holdAlerts: holdAlerts},
    		success: function(data) {
    			$scope.$root.handleServerResponse(data,"", "Going to deploy is set successfully");
    			refreshData();
    		}
    	});
    };

	$scope.validateApps = function() {
		store.action({
			path:'ag/checkAllApps',
			success: function(data) {
				$scope.$root.handleServerResponse(data,"", "Apps validated. Errors will be disaplyed in the service status.");
			}
		});
	};

    $scope.runJob = function(){
    		// Send request
    		store.action({
    			url : '/ag/runManualJob?jobClass='+$scope.selectedJob.jobClass ,
    			success: function(data) {
    				$scope.$root.handleServerResponse(data,"", "Job started to run - please verify run in log");
    			}
    		});
    };

    $scope.getAlertsOnHold = function(cursor){
		// Send request
		store.fetch({
			method : 'GET',
			url : '/ag/getAlertsOnHold?cursor='+cursor ,
			success: function(data) {
				$scope.OnHoldAlertResult = data;
			}
		});
    };

    $scope.getAlertsOnHoldSummary = function(cursor){
    	// Send request
    	store.fetch({
    		method : 'GET',
    		url : '/ag/getAlertsOnHoldSummary' ,
    		success: function(data) {
    			$scope.OnHoldAlertSummary = data;
    		}
    	});
    };

	$scope.showRemoteRevlite = function() {
		$scope.dataURL = '/ag/new/revlite';
		refreshData($state, $scope.revlitePublishRequest.accountId);
	};

    $scope.suppressAlerts = function(type){
    	// Send request
			store.action({
    			url : '/ag/suppressAlerts?type='+type ,
    			success: function(data) {
    				$scope.$root.handleServerResponse(data,"", "Alerts from type " + type + "  are suppressed");
    				refreshData();
    			}
    		});
    };

     $scope.freeAlerts = function(type){
     	// Send request
   			store.action({
     			url : '/ag/freeAlerts',
     			queryParams: {type: type},
     			success: function(data) {
     				$scope.$root.handleServerResponse(data,"", "Alerts " + (type ? "from type " + type : "") + "  are free");
     				refreshData();
     			}
     		});
     };

	$scope.showPendingRevliteEvents = function () {
		console.log("fetching pending events")
		const accountId = $scope.revlitePublishRequest.accountId;
		store.action({
			method: "GET",
			url: '/ag/new/revlite/event/pending',
			queryParams: { accountId  },
			success: function (data) {
				$scope.pendingEvents[accountId] = data;
			}
		});
	};

	$scope.discardPendingRevliteEvent = function (eventId) {
		const accountId = $scope.revlitePublishRequest.accountId;
		if (confirm('Are you sure you want to discard pending revlite event? Action is not revertible!')) {
			store.action({
				method: "DELETE",
				url: '/ag/new/revlite/event/pending',
				queryParams: { accountId, eventId  },
				success: function () {
					$scope.showPendingRevliteEvents();//reload pending events on success
				}
			});
		}
	};

    $scope.ikeV2ConfToMultiTunnelConfMigration = function(migrateAccounts) {
        migrateAccounts.response = "Sending Request...";
        if (!migrateAccounts || !migrateAccounts.accountIdsStr) {
            migrateAccounts.response = "Missing Parameters";
            return;
        }
        store.fetch({
            method : 'POST',
            url : "/ag/migrateIkeV2ConfToMultiTunnelConf",
            queryParams: {accountIdsStr: migrateAccounts.accountIdsStr, authenticityToken: authenticityToken},
            success: function(data) {
                migrateAccounts.response = "Done";
            },
            error: function() {
                migrateAccounts.response = "Bad Request";
            }
        });
    }

    angular.element(document).ready( function (){
		$scope.getAlertsOnHold("0");
		$scope.getAlertsOnHoldSummary();
    });

    // End of system properties screen


	$timeout($scope.processingLoop,200);

	function updateDateRange(type, value){
		var url = $scope.location.path();
		var params = $location.search();
		var locationString = url + "?";
		var hasKey = false;

		for (var key in params) {
			if (params.hasOwnProperty(key)) {
				if (key === type){
					locationString += '&' + type + '=' + value;
					hasKey = true;
				}
				else {
					locationString += '&' + key + '=' + params[key];
				}
			}
		}
		if(!hasKey){
			locationString += '&' + type + '=' + value;
		}

		$scope.location.url(locationString);
		$rootScope[type] = value;
	}

	$scope.$watch('revlitePublishRequest.accountId', function (newValue, oldValue) {
		if (newValue && oldValue && !_.isEqual(newValue, oldValue)) {
			//cleanup pending events when we change accountID in UI
			$scope.pendingEvents[oldValue] = undefined;
		}
	});

	$scope.$watch('start', function(newValue, oldValue) {
		if (newValue && !_.isEqual(newValue,oldValue)) {
			updateDateRange('start', newValue);
		}
	}, true);

	$scope.$watch('end', function(newValue, oldValue) {
		if (newValue && !_.isEqual(newValue,oldValue)) {
			updateDateRange('end', newValue);
		}
	}, true);

}
